import { Table } from 'antd'
import styled from 'styled-components'
import { COLORS } from 'theme'
import { FONT } from 'theme/font'

export const CustomStyledTable = styled(Table)`
  .ant-table-cell {
    border: 1px solid #e2e2e2;
    padding: ${props => (props.cellSpacing ? props.cellSpacing : '0px')};
    height: 43px;
    border-radius: 0 !important;
    background:#FFFFFF;
    padding: 3px 10px;
  }

  .ant-table-expanded-row > td:first-child{
    padding:0;
  }

  .ant-table-row > .ant-table-cell:nth-child(3) {
    border-right:none;
  }

  .ant-table-thead > tr > th:nth-child(3) {
    border-right:none;
  }

  .ant-table-content {
    overflow: auto hidden;
  }

  .ant-table-tbody > tr.ant-table-row:hover > td {
    background: ${props => (props.removeHoverEffect ? 'unset' : '')};
  }


  .ant-table table {
    border-collapse: collapse;
  }

  .ant-table-cell.ant-table-row-expand-icon-cell{
    border-left:none;
  }

  tr {
    th {
      background: '#FFFFFF;
      font-style: normal;
      font-weight: ${props => (props.fontWeight ? '600' : FONT.FW_500)};
      font-size: ${props => (props.fontSize ? '12px' : FONT.F_XS)};
      line-height: 1.125em;
      letter-spacing: 0.1em;
      text-transform: uppercase;
      color: ${COLORS.GREY_T_30};

      ::before {
        height: 0px;
      }
    }
  }
  .ant-table-pagination.ant-pagination {
    justify-content: center;
  }

  .ant-table-expanded-row td {
    padding: ${props =>
      props?.expandedRowPadding ? props?.expandedRowPadding : '0'} !important;
  }
`

export const CustomTable = styled(Table)(({ status }) => ({
  '.ant-table': {
    margin: '0px !important',
  },
  '.ant-table-tbody .ant-table-cell': {
    height: '38px',
    borderRight: `0.2px solid ${status ? 'rgb(227 94 80 / 35%)' : '#0FB680'}`,
    borderBottom: 'none',
    borderTop: 'none',
    background: 'inherit',
    padding: '0px 10px',
  },
  '.ant-table-thead': {
    height: 'unset',
    borderBottom: `0.2px solid ${status ? 'rgb(227 94 80 / 35%)' : '#0FB680'}`,
  },
  '.ant-table-thead .ant-table-cell': {
    borderBottom: 'none',
    borderTop: 'none',
    borderRight: `0.2px solid ${status ? 'rgb(227 94 80 / 35%)' : '#0FB680'}`,
    height: '38px',
    background: 'inherit !important',
    color: '#000000',
    fontWeight: 700,
    padding: '0px 10px',
  },
  '.ant-table table': {
    borderCollapse: 'collapse',
    border: 'none',
  },
  '.ant-table-content': {
    borderLeft: `4px solid ${status ? '#E35E50' : '#0FB680'}`,
    borderRight: `1px solid ${status ? '#E35E50' : '#0FB680'}`,
    borderBottom: `1px solid ${status ? '#E35E50' : '#0FB680'}`,
    borderTop: `1px solid ${status ? '#E35E50' : '#0FB680'}`,
    padding: '10px',
    background: `${status ? '#FFF0EE' : 'rgb(15 182 128 / 12%)'}`,
  },
  '.ant-table-tbody > tr >  td:first-child': {
    borderLeft: 'none',
  },
  '.ant-table-tbody > tr >  td:last-child': {
    borderRight: 'none',
  },
  '.ant-table-thead > tr >  th:first-child': {
    borderLeft: 'none',
  },
  '.ant-table-thead > tr >  th:last-child': {
    borderRight: 'none',
  },
  '.ant-table-tbody > tr.ant-table-row:hover > td': {
    background: 'unset',
  },
}))

export const TableTextSection = styled.div`
  color: #000000;
  font-size: 12px;
  font-weight: 400;
`

export const TableElement = styled.table`
  border-collapse: collapse;
  width: 100%;
  th,
  td {
    border: 1px solid #e2e2e2;
    height: 43px;
    color: #808697;
    font-size: 12px;
    font-weight: 500;
  }
  .table_head_cell {
    text-transform: uppercase;
  }
  .table-cell {
    border: 1px solid rgb(226, 226, 226);
    height: 43px;
    background: rgb(255, 255, 255);
    padding: 3px 10px;
    border-radius: 0px !important;
  }
  .collapse_th_cell {
    font-size: 10px;
    font-weight: 700;
    line-height: 20px;
    text-align: left;
    color: #000;
    padding: 0 20px;
  }
  .collapse_td_cell {
    height: 35px;
    font-size: 10px;
    color: #000000;
    font-weight: 400;
    padding: 0 20px;
  }
`

export const CollapseTHElement = styled('tr')(({ color }) => {
  return {
    th: {
      borderColor: color?.color,
      background: color?.bgColor,
    },
    'th:first-child': {
      borderLeft: `4px solid ${color?.color}`,
      borderTop: `1px solid ${color?.color}`,
      borderBottom: `1px solid ${color?.borderColor}`,
      borderRight: 'none',
    },
    'th:nth-child(2n)': {
      borderBottom: `1px solid ${color?.borderColor}`,
      borderRight: `1px solid ${color?.borderColor}`,
      borderTop: `1px solid ${color?.color}`,
      borderLeft: `1px solid ${color?.borderColor}`,
    },
    'th:last-child': {
      borderRight: `1px solid ${color?.color}`,
      borderTop: `1px solid ${color?.color}`,
      borderBottom: `1px solid ${color?.borderColor}`,
    },
  }
})

export const CollapseTRElement = styled('tr')(({ color, borderLast }) => {
  return {
    'td:last-child': {
      borderRight: '1px solid',
      borderColor: color?.color,
    },
    'td:first-child': {
      borderLeft: '4px solid',
      borderColor: color?.color,
    },
    td: {
      border: 'none',
      borderBottom: borderLast ? '1px solid' : 'none',
      background: color?.bgColor,
      borderColor: color?.color,
    },
    'td:nth-child(2n)': {
      borderLeft: `1px solid ${color?.borderColor}`,
      borderRight: `1px solid ${color?.borderColor}`,
      borderBottomColor: borderLast ? color?.color : color?.borderColor,
    },
  }
})

export const TableTDElement = styled('td')(
  ({ roleStatus, firstIndex, lastIndex }) => ({
    borderLeft: firstIndex
      ? roleStatus === 'open'
        ? '4px solid #0FB680 !important'
        : roleStatus === 'closed'
        ? '4px solid #E35E50 !important'
        : '1px solid rgb(226, 226, 226) !important'
      : '',
    borderBottom: lastIndex
      ? '1px solid rgb(226, 226, 226) !important'
      : 'none !important',
  })
)

export const StaticTDElement = styled('td')(({ color }) => {
  return {
    borderTop: `1px solid ${color?.color} !important`,
    borderBottom: `1px solid ${color?.color} !important`,
    fontSize: '10px !important',
    fontWeight: '300 !important',
    color: `#000000 !important`,
    paddingLeft: '20px',
  }
})
